import $ from "jquery";

/**
 * @fileOverview 3D视图控制插件
 * @class Control3D
 * @author for.
 * @param
 */
class Control3D {
    constructor(params) {
        let _ = this;

        _.__settings = _.settings();
        _.__nowAngleX = params.rotateX || 0;
        _.__nowAngleY = params.rotateY || 0;
        _.__nowAngleZ = params.translateZ || 0;
        _.__cache = {
            angleX: _.__nowAngleX,
            angleY: _.__nowAngleY,
            zoomZ: _.__nowAngleZ,
        }

        // 默认配置
        _.__settings = ($.isPlainObject(params))
            ? $.extend(true, {}, _.__settings, params)
            : $.extend({}, _.__settings);

        _.__container = $(_.__settings.container);
        _.__scene = $(_.__settings.scene);
        _.__events = _.events();

        _.__offsetX = _.__scene.offset().left;
        _.__offsetY = _.__scene.offset().top;
        _.__offsetWidth = _.__scene[0].offsetWidth;
        _.__offsetHeight = _.__scene[0].offsetHeight;

        _.init();
    }
    settings() {
        return {
            // 开关
            hover: false,            // 鼠标hover事件旋转视图
            hoverAngleRangeX: 20,
            hoverAngleRangeY: 20,
            level: true,              // 是否允许水平方向旋转
            vertical: true,         // 是否允许垂直方向旋转
            zoom: true,             // 是否允许缩放视图
            // 视图
            container: 'body',
            scene: ''
        }
    }
    init() {
        let _ = this;
        _.bind();
    }
    bind() {
        let _ = this;
        if (_.__settings.hover) {
            _.__scene.mousemove(hoverMoveHandler);
            return;
        }
        function hoverMoveHandler(e) {
            let moveX = e.clientX - _.__offsetX;
            let moveY = e.clientY - _.__offsetY;

            if (_.__settings.level) {
                let half = _.__offsetWidth / 2;
                let per = (moveX - half) / half
                const Ydeg = _.__settings.hoverAngleRangeX * per;
                _.__nowAngleY = -Ydeg;
                _.__cache.angleY = -Ydeg;
            }

            if (_.__settings.vertical) {
                let half = _.__offsetHeight / 2;
                let per = (moveY - half) / half
                const Xdeg = _.__settings.hoverAngleRangeY * per;
                _.__nowAngleX = -Xdeg;
                _.__cache.angleX = -Xdeg;
            }

            requestAnimationFrame(draw);
        }
        _.__container.mousedown(function (e) {
            let downX = e.clientX;
            let downY = e.clientY;
            // 事件截流
            // _.__container.mousemove(Utils.debounce(moveHandler, 200));
            _.__container.mousemove(moveHandler);
            _.__container.mouseup(function () {
                _.__cache.angleX = _.__nowAngleX;
                _.__cache.angleY = _.__nowAngleY;
                _.__container.unbind('mousemove');
                _.__container.unbind('mouseup');
            });
            function moveHandler(e) {
                let moveX = e.clientX;
                let moveY = e.clientY;
                if (_.__settings.level) _.__nowAngleY = (moveX - downX) / 10 + _.__cache.angleY;
                if (_.__settings.vertical) _.__nowAngleX = (downY - moveY) / 10 + _.__cache.angleX;
                requestAnimationFrame(draw)
            }
        });
        function draw() {
            _.__scene.css('-webkit-transform', `rotateY(${_.__nowAngleY}deg) rotateX(${_.__nowAngleX}deg) translateZ(${_.__nowAngleZ}px)`);
        }
        if (_.__settings.zoom) document.body.onmousewheel = event => {
            event = event || window.event;
            event.wheelDelta > 0 ? _.__nowAngleY += 10 : _.__nowAngleY -= 10;
            _.__scene.css('-webkit-transform', `rotateY(${_.__nowAngleY}deg) rotateX(${_.__nowAngleX}deg) translateZ(${_.__nowAngleZ}px)`);
        };
    }
    events() {
        return {
        }
    }
}

export default Control3D
